import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import { LangSwitcher } from "@/components/Navbar";
import MilesLogo from "@/components/Logo";
import BookingStepper from "@/components/booking/BookingStepper";
import { useLang } from "@/lib/i18n";

export default function BookingHeader({ step }) {
  const { t } = useLang();
  const total = t("bk.steps").length;

  return (
    <header className="sticky top-0 z-50 border-b border-ink/10 bg-white/90 backdrop-blur-xl" data-testid="booking-header">
      <div className="mx-auto flex h-[68px] max-w-[1360px] items-center justify-between gap-4 px-5 sm:px-8">
        <Link to="/" className="inline-flex items-center" data-testid="booking-logo" aria-label="MILES — retour à l'accueil">
          <MilesLogo variant="blue" className="h-[19px]" testId="booking-logo-img" />
        </Link>
        <div className="hidden lg:block">
          <BookingStepper step={step} />
        </div>
        <div className="flex items-center gap-3">
          <LangSwitcher />
          <Link to="/contact" className="hidden items-center gap-2 text-sm font-medium text-slate transition-colors hover:text-ink md:flex" data-testid="booking-help-link">
            <HelpCircle className="h-4 w-4" strokeWidth={1.5} />
            {t("bk.help")}
          </Link>
        </div>
      </div>
      <div className="border-t border-ink/5 px-5 py-2 lg:hidden" data-testid="booking-mobile-progress">
        <div className="flex items-center justify-between text-xs font-medium text-slate">
          <span>{step + 1} / {total}</span>
          <span className="text-ink">{t("bk.steps")[step]}</span>
        </div>
        <div className="mt-2 h-1 overflow-hidden rounded-full bg-ink/5">
          <div className="h-full rounded-full bg-miles transition-[width] duration-300" style={{ width: `${((step + 1) / total) * 100}%` }} />
        </div>
      </div>
    </header>
  );
}
